import React from 'react';

const FailurePage = () => {

    return (
        <div className="payment-result">
            <h2>Payment Failed</h2>
            <p>Your payment was not successful. Please try again.</p>
        </div>
    );
};

export default FailurePage;